/* eslint-disable no-unused-vars */
export enum CarteiraPermissaoTipo {
    Administrador = 1,
    Owner = 2,
    SubOwner = 3,
}